import { useCallback } from 'react'
import type { ConditionModel } from '../../../typings'
import { FormikErrors } from 'formik'
import { attributes } from './useData'
import { useTranslation } from 'react-i18next'

export function useValidation() {
  const { t } = useTranslation()
  const validate = useCallback(
    (model: ConditionModel) => {
      const { attribute, assignmentRuleConditionValues } = model
      const errors: FormikErrors<ConditionModel> = {}

      if (!attribute) {
        errors.attribute = 'A lead attribute is required to create a condition'
      }

      if (attribute && !assignmentRuleConditionValues.length) {
        // Every attribute, Territory included: this is a label lookup for something the user
        // has already chosen, so leaving it out would render "undefined is required".
        const attributeLabel = attributes(t, true).find(
          (attr) => attr.id === attribute,
        )?.name
        errors.assignmentRuleConditionValues = `${attributeLabel} is required`
      }

      return errors
    },
    [t],
  )

  return { validate }
}
